// extracted by mini-css-extract-plugin
export var container = "_6t-0";
export var error = "_6t-9";
export var label = "_6t-5";
export var light = "_6t-6";
export var md = "_6t-3";
export var sm = "_6t-2";
export var thin = "_6t-8";
export var thinBold = "_6t-7";
export var vertical = "_6t-4";
export var xs = "_6t-1";